import { forwardRef, useEffect } from "react";
import ContactForm from "./ContactForm";
import { setActiveSection } from "../../store";
import { useDispatch } from "react-redux";

function ContactFormSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("contact"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      className="w-full h-max mt-20 mb-4 flex flex-col items-center"
      ref={ref}
    >
      <h1 className="text-white text-3xl w-full pl-3 mb-7">
        I'd Love To Hear From You
      </h1>
      <ContactForm className="" />
    </div>
  );
}

export default forwardRef(ContactFormSection);
